export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/pianissimo-icon.svg?d137bed9a64f5d016235251e760c9298";